import { render, staticRenderFns } from "./InqueryDetails.vue?vue&type=template&id=4c4d8ddd&scoped=true&"
import script from "./InqueryDetails.vue?vue&type=script&lang=ts&"
export * from "./InqueryDetails.vue?vue&type=script&lang=ts&"
import style0 from "./InqueryDetails.vue?vue&type=style&index=0&id=4c4d8ddd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4d8ddd",
  null
  
)

export default component.exports